import React from 'react';
import { useNavigate } from 'react-router-dom';
import AICounselor from '../components/AICounselor';

const CounselorPage = ({ user }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      <AICounselor 
        user={user} 
        isEmbedded={false}
        onBack={() => navigate('/dashboard')}
      />
    </div>
  );
};

export default CounselorPage;
